/* PulloraX - audit fixes 23 Sept 2026 (owner approved items 1-8).
   Loaded last from snippets/pullorax-extras-data.liquid. Remove that line to revert. */
(function () {
  'use strict';

  /* F03 - cart shipping estimate.
     /cart/shipping_rates.json answers 422 ("Enter a postal code" / "Select a
     state") for 26 of the 27 destinations when no address is typed, and the old
     code read that as "no rate for this destination" - every country except
     Israel showed the quote-request message. The store's rates are set per
     COUNTRY (FedEx zones), so any valid address inside the country returns the
     same rate the checkout will charge. When Shopify asks for a postcode or a
     region, the request is repeated with a real central address of that
     country. A 503 (rate limit) is retried once. */
  var SAMPLE = {
    AU: ['NSW', '2000'], AT: ['', '1010'], BE: ['', '1000'], CA: ['ON', 'M5V 2T6'],
    CZ: ['', '11000'], DK: ['', '1050'], FI: ['', '00100'], FR: ['', '75001'],
    DE: ['', '10115'], HK: ['KL', ''], IE: ['D', 'D02 X285'], IL: ['', '6100000'],
    IT: ['RM', '00184'], MY: ['KUL', '50000'], NL: ['', '1011 AB'], NZ: ['AUK', '1010'],
    NO: ['', '0150'], PL: ['', '00-001'], PT: ['PT-11', '1100-148'], SG: ['', '018956'],
    KR: ['KR-11', '04524'], ES: ['M', '28001'], SE: ['', '111 20'], CH: ['', '8001'],
    AE: ['DU', ''], GB: ['', 'SW1A 1AA'], US: ['NY', '10001']
  };

  function initShipCalc() {
    var root = document.querySelector('[data-px-sc]');
    if (!root || root.hasAttribute('data-px-sc-v2')) return;
    root.setAttribute('data-px-sc-v2', '');
    var sel = root.querySelector('[data-px-sc-country]');
    var zip = root.querySelector('[data-px-sc-zip]');
    var oldGo = root.querySelector('[data-px-sc-go]');
    var out = root.querySelector('[data-px-sc-out]');
    if (!sel || !oldGo || !out) return;
    var go = oldGo.cloneNode(true); /* drops the old click handler */
    oldGo.parentNode.replaceChild(go, oldGo);
    var d = root.dataset;
    var fmt = window.pxMoneyFmt || '${{amount}}';

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(v) {
      var n = parseFloat(v); if (isNaN(n)) return null;
      var dd = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var i = Math.round(n).toLocaleString('en-US');
      return fmt.replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/g, i).replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, dd);
    }
    function ask(cc, prov, z) {
      var url = '/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' + encodeURIComponent(cc) +
        '&shipping_address%5Bprovince%5D=' + encodeURIComponent(prov || '') +
        '&shipping_address%5Bzip%5D=' + encodeURIComponent(z || '');
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) { return { s: r.status, j: j }; });
      });
    }
    function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
    function quoteBlock() {
      var opt = sel.options[sel.selectedIndex];
      var href = d.quoteUrl + '?country=' + encodeURIComponent(opt ? opt.getAttribute('data-name') : '');
      return '<p class="px-sc__msg">' + esc(d.tNone) + '<br><a href="' + esc(href) + '">' + esc(d.tMail) + '</a></p>';
    }

    function run() {
      var cc = sel.value; if (!cc) return;
      var sample = SAMPLE[cc] || ['', ''];
      var typed = (zip && zip.value || '').trim();
      go.disabled = true; go.textContent = d.tCalcing; out.innerHTML = '';
      var first = typed ? ask(cc, sample[0], typed) : ask(cc, sample[0], sample[1]);
      first
        .then(function (r) {
          if (r.s === 422 && typed) return ask(cc, sample[0], sample[1]);
          if (r.s === 503 || r.s === 429) return wait(1500).then(function () { return ask(cc, sample[0], typed || sample[1]); });
          return r;
        })
        .then(function (r) {
          if (r.s !== 200) {
            out.innerHTML = r.s === 422 ? quoteBlock() : '<p class="px-sc__msg">' + esc(d.tErr) + '</p>';
            return;
          }
          var rates = (r.j && r.j.shipping_rates) || [], rows = [];
          rates.forEach(function (x) {
            var m = money(x.price); if (m === null) return;
            rows.push('<div class="px-sc__rate"><b>' + esc(x.presentment_name || x.name) + '</b><span>' + esc(m) + '</span></div>');
          });
          out.innerHTML = rows.length ? rows.join('') : quoteBlock();
        })
        .catch(function () { out.innerHTML = '<p class="px-sc__msg">' + esc(d.tErr) + '</p>'; })
        .then(function () { go.disabled = false; go.textContent = d.tCalc; });
    }
    go.addEventListener('click', run);
  }

  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  function t(map, k) { var X = window.PXT; return (X && k && X[k]) || map[LANG] || map.en; }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* F05 - pack count on product cards. The unit is read from the product
     handle (language-independent): "...-3-pack" is a three-pack listing. */
  function cardUnits() {
    var cards = document.querySelectorAll('.px-c:not([data-px-au])');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i]; c.setAttribute('data-px-au', '');
      var a = c.querySelector('.px-c__link, a[href*="/products/"]');
      if (!a) continue;
      var h = (a.getAttribute('href') || '').split('?')[0];
      var m = h.match(/-(\d+)-pack(?:s)?$/);
      if (!m) continue;
      var over = c.querySelector('.px-c__over');
      if (!over) continue;
      var sub = over.querySelector('.px-c__sub');
      if (!sub) { sub = document.createElement('span'); sub.className = 'px-c__sub'; over.insertBefore(sub, over.firstChild); }
      if (sub.querySelector('.px-au-qty')) continue;
      var q = document.createElement('span'); q.className = 'px-au-qty'; q.textContent = '×' + m[1];
      sub.appendChild(q);
    }
  }

  /* F09 - category intro: first paragraph and the format links stay; the
     longer explanation and the wholesale line fold into one disclosure. */
  function foldIntro() {
    var lede = document.querySelector('.px-coll .px-coll__about .px-lede');
    if (!lede || lede.hasAttribute('data-px-au')) return;
    lede.setAttribute('data-px-au', '');
    var ps = lede.querySelectorAll(':scope > p');
    var move = [];
    for (var i = 2; i < ps.length; i++) move.push(ps[i]);
    var b2b = lede.parentNode.querySelector(':scope > .px-b2b-line');
    if (b2b) move.push(b2b);
    if (!move.length) return;
    var d = document.createElement('details'); d.className = 'px-au-more';
    var s = document.createElement('summary');
    s.textContent = t({ it: 'Scopri di più su questa categoria', en: 'More about this category', he: 'מידע נוסף על הקטגוריה', fr: 'En savoir plus sur cette catégorie', de: 'Mehr zu dieser Kategorie' }, 'more_category');
    d.appendChild(s);
    lede.parentNode.insertBefore(d, (b2b && b2b.parentNode === lede.parentNode) ? b2b : lede.nextSibling);
    move.forEach(function (n) { d.appendChild(n); });
  }

  /* F13 - the "ask us before ordering" invitation, once, on the product page,
     only where the low-stock line is shown. */
  var ASK = { it: 'Ti servono più pezzi? Contattaci prima di ordinare.', en: 'Need more? Ask us before ordering.', he: 'צריכים יותר? דברו איתנו לפני ההזמנה.', fr: 'Besoin de plus ? Écrivez-nous avant de commander.', de: 'Mehr benötigt? Fragen Sie uns vor der Bestellung.' };
  function pdpAsk() {
    var low = document.querySelector('.px-pdp__info .px-lowstock');
    if (!low || document.querySelector('.px-au-ask')) return;
    var p = document.createElement('p'); p.className = 'px-au-ask';
    var a = document.createElement('a'); a.href = ROOT.replace(/\/$/, '') + '/pages/contact'; a.textContent = t(ASK, 'need_more');
    p.appendChild(a);
    low.parentNode.insertBefore(p, low.nextSibling);
  }

  /* F16 - key facts beside the buy button, taken verbatim (label + value) from
     the product's own specification table on the same page. */
  function pdpFacts() {
    var price = document.querySelector('.px-pdp__info .px-pdp__price');
    if (!price || document.querySelector('.px-au-facts')) return;
    var rows = document.querySelectorAll('.px-spec__table .px-spec__row:not(.px-spec__row--list)');
    if (!rows.length) return;
    /* set code, packs per box, cards per pack - matched on the table's own
       label in each storefront language (spaces and hyphens ignored). */
    var keys = ['setcode', 'packsperbox', 'cardsperpack',
      'קודהסט', 'פאקיםבבוקס', 'קלפיםבפאק',
      'codeduset', 'boostersparbox', 'cartesparbooster',
      'packsprobox', 'kartenpropack'];
    var ul = document.createElement('ul'); ul.className = 'px-au-facts';
    var n = 0;
    for (var i = 0; i < rows.length; i++) {
      var dt = rows[i].querySelector('dt'), dd = rows[i].querySelector('dd');
      if (!dt || !dd) continue;
      var norm = (dt.textContent || '').toLowerCase().replace(/[\s\-‐-―]/g, '');
      if (keys.indexOf(norm) < 0) continue;
      var li = document.createElement('li');
      var sp = document.createElement('span'); sp.textContent = dt.textContent.trim();
      li.appendChild(sp); li.appendChild(document.createTextNode(' ' + dd.textContent.trim()));
      ul.appendChild(li); n++;
    }
    if (n) price.parentNode.insertBefore(ul, price.nextSibling);
  }

  /* F11 - measure whichever bottom bar is showing and lift the floating
     buttons above it.

     PERFORMANCE (1 Oct 2026, owner approved). This used to run every 1.5s
     forever (setInterval) and after every change anywhere in the page, and
     each run forced a full style + layout pass and then re-wrote a CSS
     variable on <html>, which re-styled the whole page. PageSpeed showed
     ~7.6s of Style & Layout work. Now:
       - the value is written only when it actually changed;
       - there is no timer;
       - it runs on scroll, resize, page load, cart updates, when a bar is
         added to the page, when a bar's own class/style/hidden changes, when
         <html>/<body> change class (drawers, menus), and when a bar finishes
         a slide-in/out transition or animation.
     The floating buttons sit exactly where they did; only the needless
     re-measuring is gone. */
  var BAR_SEL = '#px-shopbar, .px-buybar, .pxb__bar';
  var lastH = -1, lastCart = null;
  function bars() {
    var h = 0, cartBar = false;
    var list = document.querySelectorAll(BAR_SEL);
    for (var i = 0; i < list.length; i++) {
      var el = list[i], cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (r.height <= 0 || r.top >= innerHeight - 1) continue;
      h = Math.max(h, Math.round(innerHeight - r.top));
      if (el.id === 'px-shopbar' && el.classList.contains('px-shopbar--cart')) cartBar = true;
    }
    if (h !== lastH) { lastH = h; document.documentElement.style.setProperty('--px-au-bar', h + 'px'); }
    if (cartBar !== lastCart) { lastCart = cartBar; document.documentElement.classList.toggle('px-au-barcart', cartBar); }
  }
  var barTick = false;
  function barsSoon() { if (barTick) return; barTick = true; requestAnimationFrame(function () { barTick = false; bars(); }); }

  var barObs = null;
  try { barObs = new MutationObserver(barsSoon); } catch (e) {}
  var rootsWatched = false;
  /* Starts watching any bar not watched yet; true if a new one was found. */
  function watchBars() {
    if (!barObs) return false;
    if (!rootsWatched && document.body) {
      rootsWatched = true;
      barObs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      barObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    var found = false;
    var list = document.querySelectorAll(BAR_SEL);
    for (var i = 0; i < list.length; i++) {
      if (list[i].__pxBarWatch) continue;
      list[i].__pxBarWatch = true; found = true;
      barObs.observe(list[i], { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }
    return found;
  }
  function onBarMotion(e) {
    var el = e.target;
    if (el && el.matches && el.matches(BAR_SEL)) barsSoon();
  }

  /* F07 - on the translated storefronts (/he, /fr, /de) links written into
     section settings as "/collections/..." sent the visitor back to the English
     site. Internal shop links get the storefront's language prefix. */
  var PFX = ROOT.replace(/\/$/, '');
  var LOCAL_RE = /^\/(collections|pages|products|blogs|search|cart)(\/|\?|#|$)/;
  function localLinks() {
    if (!PFX) return;
    var as = document.querySelectorAll('a[href^="/"]:not([data-px-au-l])');
    for (var i = 0; i < as.length; i++) {
      var a = as[i]; a.setAttribute('data-px-au-l', '');
      var h = a.getAttribute('href');
      if (!LOCAL_RE.test(h) || a.closest('form[action*="localization"], [hreflang]')) continue;
      a.setAttribute('href', PFX + h);
    }
  }

  /* F08 - product-format and packaging labels on cards and on the product
     page come from product data and are English only; Hebrew labels here. */
  var HE_LABELS = {
    'Booster Pack': 'חבילת בוסטר',
    'Booster Pack Bundle': 'מארז חבילות בוסטר',
    'Booster Box': 'בוסטר בוקס',
    'Deck Set': 'סט חפיסות',
    'Special Set': 'סט מיוחד',
    'Promo Pack': 'חבילת פרומו',
    'Original Japanese Shrink': 'שרינק יפני מקורי',
    'Factory Sealed': 'אטום מהמפעל',
    'No Shrink': 'ללא שרינק'
  };
  function heLabels() {
    if (LANG !== 'he') return;
    var els = document.querySelectorAll('.px-c__sub:not([data-px-au-t]), .px-cardfacts span:not([data-px-au-t]), .px-pdp__line:not([data-px-au-t])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i]; el.setAttribute('data-px-au-t', '');
      for (var n = el.firstChild; n; n = n.nextSibling) {
        if (n.nodeType !== 3) continue;
        var raw = n.nodeValue, parts = raw.split('·');
        var changed = false;
        for (var j = 0; j < parts.length; j++) {
          var k = parts[j].trim();
          if (HE_LABELS[k]) { parts[j] = parts[j].replace(k, HE_LABELS[k]); changed = true; }
        }
        if (changed) n.nodeValue = parts.join('·');
      }
    }
  }

  /* F22 (owner, 23 Sept) - wholesale application: every field stays, only the
     email is mandatory (it is the one thing needed to reply). */
  function wholesaleForm() {
    var f = document.getElementById('PulloraXWholesale');
    if (!f || f.hasAttribute('data-px-au')) return;
    f.setAttribute('data-px-au', '');
    var req = f.querySelectorAll('[required]');
    for (var i = 0; i < req.length; i++) {
      var inp = req[i];
      if (inp.type === 'email') continue;
      inp.removeAttribute('required');
      inp.removeAttribute('aria-required');
      var lab = inp.closest('label');
      if (!lab) continue;
      for (var n = lab.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && /\s*\*\s*$/.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/\s*\*\s*$/, ''); break; }
      }
    }
  }

  function all() { cardUnits(); foldIntro(); pdpAsk(); pdpFacts(); localLinks(); heLabels(); wholesaleForm(); watchBars(); barsSoon(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  window.addEventListener('scroll', barsSoon, { passive: true });
  window.addEventListener('resize', barsSoon);
  document.addEventListener('transitionend', onBarMotion, true);
  document.addEventListener('animationend', onBarMotion, true);
  document.addEventListener('px:cart-updated', barsSoon);
  try {
    new MutationObserver(function () { cardUnits(); pdpAsk(); localLinks(); heLabels(); if (watchBars()) barsSoon(); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShipCalc);
  else initShipCalc();
  document.addEventListener('px:cart-updated', initShipCalc);
})();
